import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { addNewSalesInvoicesRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE, IRoleEnum.STORE_EMPLOYEE];

const addNewSalesInvoicesRouteMetadata: IRouteMetadataObj<
  typeof addNewSalesInvoicesRoutesObj
> = {
  create: {
    title: "addNewSalesInvoices.create.title",
    description: "empty",
    lazy: () => import("@/pages/addNewSalesInvoices/page"),
    mode: "create",
    type: "main",
    icon: "BarcodeBoxLine",
    breadcrumbs: [],
    pageState: { isPageFullMode: true },
    permission,
  },
};

export const addNewSalesInvoicesRoutes = createRoute<
  typeof addNewSalesInvoicesRoutesObj
>(addNewSalesInvoicesRoutesObj, addNewSalesInvoicesRouteMetadata);
